// Version : 0.0.1
// Author : VISHAL BHARATHI
// CREATED DATA: 18-09-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import TransferFunderActionTypes from './transfer-funder.types';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	fetchAllLoanIndexListForGroupFailure,
	fetchAllLoanIndexListForGroupResponseChanged,
	fetchAllLoanIndexListForGroupSuccess,
	updateTransferFunderDetailsFailure,
	updateTransferFunderDetailsResponseChanged,
	updateTransferFunderDetailsSuccess,
} from './transfer-funder.action';
import {
	fetchAllLoanIndexListForGroup,
	updateTransferFunderDetails,
} from './transfer-funder.service';

/** ********************* UPDATE TRANSFER FUNDER DETAILS START ******************** */
export function* updateTransferFunderDetailsSaga({ payload }: any) {
	try {
		const key = 'UpdateTransferFunderKey';
		const { databaseName, loanIndexID, investorID, investorName, investedAmount } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			LoanIndexID: loanIndexID,
			InvestorID: investorID,
			FunderName: investorName,
			InvestorAmount: investedAmount,
			NewInvestorAmount: investedAmount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateTransferFunderDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateTransferFunderDetailsFailure(responseData.data));
		} else {
			yield put(updateTransferFunderDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateTransferFunderDetailsFailure(error));
	}
}

export function* resetTransferFunderDetailsResponse() {
	yield put(updateTransferFunderDetailsResponseChanged());
}

export function* onUpdateTransferFunderDetails() {
	yield takeLatest(
		TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_START,
		updateTransferFunderDetailsSaga,
	);
}

export function* onUpdateTransferFunderDetailsResponseReset() {
	yield takeLatest(
		TransferFunderActionTypes.UPDATE_TRANSFER_FUNDER_DETAILS_RESPONSE_RESET,
		resetTransferFunderDetailsResponse,
	);
}
/** ********************* UPDATE TRANSFER FUNDER DETAILS END ******************** */

/** ********************* FETCH ALL LOAN INDEX LIST FOR GROUP START ******************** */
export function* fetchAllLoanIndexListForGroupSaga({ payload }: any) {
	try {
		const key = 'FetchAllLoanIndexListForGroupKey';
		const { databaseName, branchID, type, centerID, groupID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			BranchID: branchID,
			Type: type,
			LocationID: centerID,
			GroupID: groupID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAllLoanIndexListForGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllLoanIndexListForGroupFailure(responseData.data));
		} else {
			yield put(fetchAllLoanIndexListForGroupSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllLoanIndexListForGroupFailure(error));
	}
}

export function* resetFetchAllLoanIndexListForGroupResponse() {
	yield put(fetchAllLoanIndexListForGroupResponseChanged());
}

export function* onFetchAllLoanIndexListForGroup() {
	yield takeLatest(
		TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_START,
		fetchAllLoanIndexListForGroupSaga,
	);
}

export function* onFetchAllLoanIndexListForGroupResponseReset() {
	yield takeLatest(
		TransferFunderActionTypes.FETCH_ALL_LOAN_INDEX_LIST_FOR_GROUP_RESPONSE_RESET,
		resetFetchAllLoanIndexListForGroupResponse,
	);
}
/** ********************* FETCH ALL LOAN INDEX LIST FOR GROUP END ******************** */

export function* transferFunderSaga() {
	yield all([
		call(onUpdateTransferFunderDetails),
		call(onUpdateTransferFunderDetailsResponseReset),
		call(onFetchAllLoanIndexListForGroup),
		call(onFetchAllLoanIndexListForGroupResponseReset),
	]);
}
